export const ImageGridMode = {
  BROWSE: 'browse',
  UPLOAD: 'upload',
};
